import * as yup from 'yup';
import cpf from './cpf';
import cnh from './cnh';
import cellPhone from './cellPhone';
import telephone from './telephone';
import telephoneOrCellPhone from './telephoneOrCellPhone';
import cnhFirstLicense from './cnhFirstLicense';
import cnhExpirationDate from './cnhExpirationDate';
import minDate from './minDate';
import maxDate from './maxDate';
import renavam from './renavam';
import year from './year';
import cnpj from './cnpj';
import cpfOrCnpj from './cpfOrCnpj';
import unique from './unique';
import chassis from './chassis';
import zipCode from './zipCode';
import name from './name';
import motherName from './motherName';
import fatherName from './fatherName';
import rntrc from './rntrc';

yup.addMethod(yup.string, 'cpf', cpf);
yup.addMethod(yup.string, 'cnh', cnh);
yup.addMethod(yup.string, 'cnhFirstLicense', cnhFirstLicense);
yup.addMethod(yup.string, 'cnhExpirationDate', cnhExpirationDate);
yup.addMethod(yup.string, 'cellPhone', cellPhone);
yup.addMethod(yup.string, 'telephone', telephone);
yup.addMethod(yup.string, 'telephoneOrCellPhone', telephoneOrCellPhone);
yup.addMethod(yup.string, 'minDate', minDate);
yup.addMethod(yup.string, 'maxDate', maxDate);
yup.addMethod(yup.string, 'renavam', renavam);
yup.addMethod(yup.string, 'chassis', chassis);
yup.addMethod(yup.string, 'year', year);
yup.addMethod(yup.string, 'cnpj', cnpj);
yup.addMethod(yup.string, 'cpfOrCnpj', cpfOrCnpj);
yup.addMethod(yup.string, 'unique', unique);
yup.addMethod(yup.string, 'name', name);
yup.addMethod(yup.string, 'motherName', motherName);
yup.addMethod(yup.string, 'fatherName', fatherName);
yup.addMethod(yup.string, 'zipCode', zipCode);
yup.addMethod(yup.string, 'rntrc', rntrc);

yup.setLocale({
  mixed: {
    required: 'Este campo é obrigatório.',
  },
  string: {
    length: 'Deve conter ${length} caracteres',
  },
});

export { default as validate } from './validate';
export * from 'yup';
